// =============================
// Email: info@ebenmonney.com
// www.ebenmonney.com/templates
// =============================

import { Component, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { fadeInOut, detailExpand } from '../../services/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { AccountService } from "../../services/account.service";
import { Offer, PhotoDetail, OfferDetail, OfferVM, OfferDetailVM, ManualOfferRow } from 'src/app/models/offer.model';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { OfferVm } from 'src/app/models/offerVm.model';
import { Product } from 'src/app/models/Product.model';
import { Poze } from 'src/app/models/Poze.model';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { AppTranslationService } from 'src/app/services/app-translation.service';
import { SelectionModel } from '@angular/cdk/collections';
import { EditDialogComponent } from '../editDialogComponent/editDialogComponent.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
  animations: [fadeInOut, detailExpand]
})

export class OfferComponent {
  private isSaving: boolean;
  private isNew: boolean;
  offerForm: FormGroup;
  offer: Offer;
  definireOffer: boolean = false;

  compensareDetaliata: Offer;

  id: string = '';
  subject: string = '';
  // Compact columns shown on the collapsed row; the rest live in the expandable
  // detail panel below each row (Material expandable-row pattern).
  displayedColumns = ['actions', 'id', 'summary', 'date', 'expand'];
  // Currently open row in the expandable list (null = all collapsed).
  expandedElement: OfferVm | null = null;

  toggleRow(offer: OfferVm, event?: Event) {
    if (event) { event.stopPropagation(); }
    this.expandedElement = this.expandedElement === offer ? null : offer;
  }

  isExpanded(offer: OfferVm): boolean {
    return this.expandedElement === offer;
  }

  // Preserve the grid scroll position when opening an offer and returning, so
  // Back doesn't dump the user at the bottom of the list.
  private savedListScrollTop = 0;
  private restoreListScrollPending = false;

  private get scrollContainer(): Element {
    return document.querySelector('.mat-sidenav-content')
      || document.scrollingElement
      || document.documentElement;
  }

  private saveListScroll() {
    const el = this.scrollContainer as HTMLElement;
    this.savedListScrollTop = el ? el.scrollTop : 0;
  }

  private restoreListScroll() {
    const top = this.savedListScrollTop;
    // Wait a tick so the reloaded rows are in the DOM before scrolling.
    setTimeout(() => {
      const el = this.scrollContainer as HTMLElement;
      if (el) { el.scrollTop = top; }
    }, 0);
  }
  // An offer created without login (anonymous) is marked with user === 'Anonymous'.
  get isOfferAnonymous(): boolean {
    return !!this.offer && this.offer.user === 'Anonymous';
  }

  // Detail (view) products table — hide the dealer price for anonymous offers.
  get displayedColumnsProduct(): string[] {
    const cols = ['vehicleReference', 'productgrup', 'productnumber', 'description', 'descriptionfr', 'descriptionen', 'descriptionro', 'PriceDealer', 'PriceFinalCustomer'];
    return this.isOfferAnonymous ? cols.filter(c => c !== 'PriceDealer') : cols;
  }

  // Edit-mode products tables — same rule.
  get displayedColumnsProducts(): string[] {
    const cols = ['select', 'vehicleReference', 'productgrup', 'productnumber', 'description', 'descriptionfr', 'descriptionen', 'descriptionro', 'PriceDealer', 'PriceFinalCustomer'];
    return this.isOfferAnonymous ? cols.filter(c => c !== 'PriceDealer') : cols;
  }
  editareOferta: boolean = false;
  isDataLoaded: boolean = false;
  loadingIndicator: boolean = true;
  formResetToggle: boolean = true;
  _currentUserId: string;
  data: OfferVm[];
  dataSource: MatTableDataSource<OfferVm>;
  dataPoze: Poze[];
  dataProducts: Product[];
  dataSelectedProducts: Product[];
  dataSourceProducts: MatTableDataSource<Product>;
  dataSourcePoze: MatTableDataSource<Poze>;
  dataSourceSelectedProducts: MatTableDataSource<Product>;
  selection = new SelectionModel<Product>(true, []);
  dataSourceProductsCarReference: Product[];
  dataSelectedDependentProducts: Product[];
  dataSourceProductsDependent: MatTableDataSource<Product>;
  listDependentProduct: boolean = false;

  carReference: string;
  tip_export: string = 'DOC';
  browserLang: string = "en";
  showEN: boolean = false;
  showNI: boolean = true;
  showRO: boolean = true;
  showFR: boolean = true;

  initialDate: Date = new Date();
  finalDate: Date = new Date();

  dataOfferDetails: OfferDetail[];
  dataOfferDetailsSource: MatTableDataSource<OfferDetail>;
  dataOfferPhotosSource: MatTableDataSource<PhotoDetail>;

  // Rows the user types by hand on the view screen; saved separately and picked
  // up by the generated documents.
  manualRows: ManualOfferRow[] = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  addMonths = (date: Date, months: number): Date => {
    let result = new Date(date);
    result.setDate(result.getMonth() + months);
    return result;
  };

  afiseazaDate() {
    this.loadingIndicator = true;

    let id = this.id == null || this.id == "" ? "undefined" : this.id;
    let subject = this.subject == null || this.subject == "" ? "undefined" : this.subject;
    let initialDate = this.initialDate == null ? "undefined" : this.formatOnlyDate(this.initialDate, ".");
    let finalDate = this.finalDate == null ? "undefined" : this.formatOnlyDate(this.finalDate, ".");

    this.accountService
      .getOfferList(id, subject, initialDate, finalDate)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.data = liniiReconverted;

        this.dataSource.data = this.data;

        this.isDataLoaded = true;

        setTimeout(() => { this.loadingIndicator = false; }, 1500);

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        // Returning from an offer: put the grid back where it was.
        if (this.restoreListScrollPending) {
          this.restoreListScrollPending = false;
          this.restoreListScroll();
        }
      },
        error => {
        });
  }
  
  ngAfterContentInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  // Export the full offers grid (all rows returned by the search, not just the current page)
  // to an .xlsx file. Mirrors the visible columns; action buttons are not exported.
  exportExcel() {
    let rows = this.data == null ? [] : this.data;

    let exportData = rows.map((offer: any) => {
      let car = offer.car || <any>{};
      let carParts = [car.make, car.model, car.body, car.variant, car.wheelbase, car.height, car.transmission]
        .map(v => v == null ? '' : v)
        .join(' , ');

      return {
        'Offer ID': offer.id,
        'Date': offer.createdDate,
        'Car': carParts,
        'User': offer.user,
        'Companie': offer.companie ? offer.companie.denumire : '',
        'Subject': offer.subject,
        'Client name': offer.clientName,
        'Email': offer.email,
        'Phone': offer.phone,
        'Reference': car.modelAccess
      };
    });

    let worksheet = XLSX.utils.json_to_sheet(exportData);
    let workbook: XLSX.WorkBook = { Sheets: { 'Offers': worksheet }, SheetNames: ['Offers'] };
    let excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    let blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(blob, 'Offers_' + this.formatOnlyDate(new Date(), '-') + '.xlsx');
  }

  reset() {
    this.id = '';
    this.subject = '';
    this.initialDate = new Date();
    this.initialDate.setMonth(this.initialDate.getMonth() - 3);
    this.finalDate = new Date();
    this.afiseazaDate();
  }

  modificare(offer: Offer) {
    if (!this.definireOffer) { this.saveListScroll(); }
    this.definireOffer = true;
    this.offer = offer;

    this.accountService
      .getOfferListProductPhoto(offer.id)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        let dataOffer = liniiReconverted[0];

        if (dataOffer != null) {
          this.offer = dataOffer;

          let allDetails = dataOffer.offerDetails || [];
          // Product-based rows stay in the read-only grid; manual rows (no
          // productId) load into the editable section below it.
          let productRows = allDetails.filter(d => d.productId);
          let manualDetails = allDetails.filter(d => !d.productId);

          this.manualRows = manualDetails.map(d => {
            let row = new ManualOfferRow();
            row.description = d.descriptionmanual || (d.product ? d.product.description : '');
            row.pricedealer = d.pricedealer;
            row.pricefinalcustomer = d.pricefinalcustomer;
            return row;
          });

          this.dataOfferDetails = productRows;
          this.dataOfferDetailsSource.data = productRows;
          this.dataOfferPhotosSource.data = dataOffer.offerPhotos;
        }

        this.isDataLoaded = true;
      },
        error => {
        });
  }

  verificareStergere(offer: Offer) {
    this.alertService.showDialog('Delete', 'Do you confirm the deletion?', DialogType.confirm, () => this.stergeOffer(offer));
  }

  stergeOffer(offer: Offer) {
    let newOffer = new OfferVM();
    newOffer.id = offer.id;
    newOffer.status = "D";
    
    this.accountService.saveOffer(newOffer).subscribe(
      role => {
        this.saveSuccessHelper(this.offer, `Offer deleted!`);
        this.afiseazaDate();
      },
      error => this.saveFailedHelper(error));
  }

  adaugare() {
    this.definireOffer = true;
    this.offer = new Offer();
  }

  constructor(
    private translate: TranslateService,
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private translationService: AppTranslationService,
    private accountService: AccountService,
    public dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource<OfferVm>();
    this.dataOfferDetailsSource = new MatTableDataSource<OfferDetail>();
    this.dataOfferPhotosSource = new MatTableDataSource<PhotoDetail>();
    this.dataSourceProducts = new MatTableDataSource<Product>();
    this.dataSourceSelectedProducts = new MatTableDataSource<Product>();
    this.dataSourceProductsDependent = new MatTableDataSource<Product>();
    this.dataSourcePoze = new MatTableDataSource<Poze>();
    this.buildForm();
  }

  selectionLanguage() {
    if (this.browserLang == "fr") {
      this.showFR = false;
      this.showEN = true;
      this.showNI = true;
      this.showRO = true;
    }
    if (this.browserLang == "en") {
      this.showFR = true;
      this.showEN = false;
      this.showNI = true;
      this.showRO = true;
    }
    if (this.browserLang == "ar") {
      this.showFR = true;
      this.showEN = true;
      this.showNI = true;
      this.showRO = false;
    }
    if (this.browserLang == "de") {
      this.showFR = true;
      this.showEN = true;
      this.showNI = false;
      this.showRO = true;
    }
  }

  ngOnInit() {
    this.offer = new Offer();
    this.initialDate.setMonth(this.initialDate.getMonth() - 3);
    this.afiseazaDate();
    var selectedLanguage = window.selectedLanguage;
    if (selectedLanguage == null || selectedLanguage == undefined) {
      selectedLanguage = 'en';
    }
    this.translationService.changeLanguage(selectedLanguage);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (event.lang != null && event.lang != "undefined") {
        selectedLanguage = event.lang;
        window.selectedLanguage = selectedLanguage;
      }
      else if (event.lang == null || event.lang == "undefined") {
        this.browserLang = selectedLanguage;
      }
      this.browserLang = selectedLanguage;
      this.selectionLanguage();
    });
    this.browserLang = selectedLanguage;
    this.selectionLanguage();
   }
  
  save(offer: OfferVM) {
    this.offer.offerDetails = [];
    for (let product of this.dataSelectedProducts.filter(f => f.selected === true)) {
      let offerDetail = new OfferDetailVM;
      offerDetail.productId = product.id;
      offer.offerDetails.push(offerDetail);
    }

    this.accountService.saveOffer(offer).subscribe(
      role => {
        this.editareOferta = false;
        this.saveSuccessHelper(this.offer, `Offer saved successfully!`);
      },
      error => this.saveFailedHelper(error));
  }

  addManualRow() {
    this.manualRows.push(new ManualOfferRow());
  }

  removeManualRow(index: number) {
    this.manualRows.splice(index, 1);
  }

  saveManualRows() {
    // Send every row (including empty ones); the server ignores fully-empty rows
    // and replaces the previous manual set, so this also handles deletions.
    let payload = this.manualRows.map(r => ({
      descriptionmanual: r.description,
      pricedealer: r.pricedealer != null ? r.pricedealer.toString() : '',
      pricefinalcustomer: r.pricefinalcustomer != null ? r.pricefinalcustomer.toString() : ''
    }));

    this.alertService.startLoadingMessage('Saving rows...');
    this.accountService.saveOfferManualDetails(this.offer.id.toString(), payload).subscribe(
      result => {
        this.alertService.stopLoadingMessage();
        this.alertService.showMessage("Success", "Manual rows saved!", MessageSeverity.success);
        // Reload so the grid, the manual editor and the totals reflect what was stored.
        this.modificare(this.offer);
      },
      error => this.saveFailedHelper(error));
  }

  private saveSuccessHelper(offer?: Offer, mesaj?: string) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();

    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);

    this.definireOffer = false;
    this.afiseazaDate();
  }
  private saveSuccessHelperGenerateOffer(mesaj?: string) {
    this.alertService.stopLoadingMessage();
    this.alertService.showMessage("Success", mesaj, MessageSeverity.success);
  }

  private saveFailedHelper(error: any) {
    this.isSaving = false;
    this.alertService.stopLoadingMessage();
    this.alertService.showStickyMessage("Save Error", "Errors: ", MessageSeverity.error, error);
    this.alertService.showStickyMessage(error, null, MessageSeverity.error);
  }

  public generareoffer(offer: Offer) {
    this.alertService.startLoadingMessage('Offer generation...');
    this.accountService.downloadOffer(this.tip_export, offer.id.toString(), this.browserLang).subscribe(result => {
      let blob = new Blob(result, {
        type: 'application/pdf' // must match the Accept type
      });
      if (this.tip_export === 'PDF') {
        let filename = 'Offer_' + offer.id + '.pdf';
        FileSaver.saveAs(blob, filename);
      }
      else if (this.tip_export === 'XLSX') {
        let filename = 'Offer_' + offer.id + '.xlsx';
        FileSaver.saveAs(blob, filename);
      }
      else if (this.tip_export === 'DOC') {
        let filename = 'Offer_' + offer.id + '.docx';
        FileSaver.saveAs(blob, filename);
      }
      this.saveSuccessHelperGenerateOffer(`The offer has been generated!`);
    });
  }
  
  private buildForm() {
    this.offerForm = this.formBuilder.group({
      tbModelAccess: ['', [Validators.required],],
      tbCar: ['', [Validators.required],],
      tbUser: ['', [Validators.required],],
      tbCompanie: ['', [Validators.required],],
      tbSubject: ['', [Validators.required],], 
      tbClientName: ['', [Validators.required],],
    });
  }

  get tbModelAccess() {
    return this.offerForm.get('tbModelAccess');
  }

  get tbCar() {
    return this.offerForm.get('tbCar');
  }

  get tbUser() {
    return this.offerForm.get('tbUser');
  }

  get tbCompanie() {
    return this.offerForm.get('tbModelAccess');
  }

  get tbSubject() {
    return this.offerForm.get('tbSubject');
  }

  get tbClientName() {
    return this.offerForm.get('tbClientName');
  }

  private cancel() {
    this.definireOffer = false;
    this.editareOferta = false;
    this.restoreListScrollPending = true;
    this.afiseazaDate();
  }

  GetPhotoUrl(poza: Poze): string {
    return '/' + poza.vehicleReference + "_" + poza.photoReference + "_" + poza.id + ".jpg";
  }

  editOffer(offer: OfferVm) {
    this.editareOferta = true;
    this.carReference = offer.car.modelAccess;
    this.dataSelectedProducts = [];
    this.dataSelectedDependentProducts = [];
    this.onProductgrupSelected("undefined", offer.car.make);
  }

  onProductgrupSelected(productgrupSelectat: string, marca: string) {
    this.accountService
      .getProductLists("undefined", "undefined", this.carReference, "undefined", "undefined", "undefined", productgrupSelectat, "undefined", "undefined", "undefined", "undefined", "undefined", "undefined", marca)
      .subscribe(results => {

        let linii = results[0];

        let liniiReconverted = JSON.parse(JSON.stringify(linii));

        this.dataProducts = liniiReconverted;

        if (productgrupSelectat === "undefined") {
          this.dataSourceProductsCarReference = this.dataProducts;
          for (let product of this.dataProducts) {
            for (let selectedProduct of this.offer.offerDetails) {
              if (product.id == selectedProduct.product.id) {
                product.selected = true;
                this.dataSelectedProducts.push(product);
              }
            }
          }
        }

        for (let product of this.dataProducts) {
          for (let selectedProduct of this.dataSelectedProducts) {
            if (product.id == selectedProduct.id) {
              product.selected = true;
            }
          }
          for (let selectedProduct of this.dataSelectedDependentProducts) {
            if (product.id == selectedProduct.id) {
              product.selectedDependentProduct = true;
            }
          }
        }

        this.dataSourceProducts.data = this.dataProducts;
        this.dataSourceSelectedProducts.data = this.dataProducts;

        this.definireOffer = false;
        this.definireOffer = true;
      },
        error => {
          this.definireOffer = true;
          this.definireOffer = false;
        });
  }

  getDependentProductsList() {
    for (let product of this.dataProducts) {
      for (let selectedProduct of this.dataSelectedDependentProducts) {
        if (product.id == selectedProduct.id) {
          this.listDependentProduct = false;
          product.selectedDependentProduct = false;
          product.selected = false;
        }
      }
    }

    this.dataSelectedDependentProducts.forEach((product) => {
      this.dataSelectedProducts = this.dataSelectedProducts.filter(f => f.id != product.id);
    });

    this.dataSelectedDependentProducts = [];

    this.dataSelectedProducts.forEach((product) => {
      if (product.depedentProduct !== null) {
        let idProducts = product.depedentProduct.split('#');

        for (var i = 0; i <= idProducts.length; i++) {
          let productInList = this.dataSourceProductsCarReference.find(f => f.id == idProducts[i]);
          if (productInList != null) {
            this.dataSelectedProducts.push(productInList);
            this.dataSelectedDependentProducts.push(productInList);
            productInList.selected = true;
          }
        }

        for (let product of this.dataProducts) {
          for (let selectedProduct of this.dataSelectedProducts) {
            if (product.id == selectedProduct.id) {
              product.selected = true;
            }
          }

          for (let selectedProduct of this.dataSelectedDependentProducts) {
            if (product.id == selectedProduct.id) {
              this.listDependentProduct = true;
              product.selectedDependentProduct = true;
            }
          }
        }
      }
    });
    this.dataSelectedDependentProducts = this.dataSelectedDependentProducts.filter((item, i, ar) => ar.indexOf(item) === i);
    this.dataSelectedProducts = this.dataSelectedProducts.filter((item, i, ar) => ar.indexOf(item) === i);
    this.dataSourceProductsDependent.data = this.dataSelectedDependentProducts;
  }

  MarkSelectionOfProduct(product: Product) {
    let currentProductInList = this.dataSelectedProducts.find(f => f.id === product.id);
    if (product.selected) {
      if (currentProductInList == null) {
        this.dataSelectedProducts.push(product);
      }
    }
    else {
      if (currentProductInList !== null) {
        this.dataSelectedProducts = this.dataSelectedProducts.filter(obj => obj !== currentProductInList);
      }
    }
    this.getDependentProductsList();
  }

  formatOnlyDate(value: Date, separator: string): string {
    var date = new Date(value);
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();

    return [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      date.getFullYear()
    ].join(separator);
  }

  clonareOferta(offer: OfferVM) {
    const dialogRef = this.dialog.open(EditDialogComponent, {
      disableClose: true,
      width: '500px',
      data: { offer: offer }
    });

    dialogRef.componentInstance.saveFromParent.subscribe(result => {
      if (result === true) {
        this.reset();
      }
    });
  }

}
